<section class="section more-proyects" id='more-proyects'>
    <div class="container">
        <div class="section-box">
            <div data-aos="fade-up" data-aos-duration="1000">
                <h3 class="section-title">
                    <span class='n-section-title'>04.</span> Estudios
                </h3>
            
                <div id="estudio" class="col-6 col-md-6" *ngFor="let estudio of AboutEstudios">
                    {{estudio?.estudio}}
                  </div>
            </div>
        </div>
    </div>
</section>
